'use client'
import Script from 'next/script';
import {ToastContainer} from "./ToastNotification";
import { Fragment } from 'react';

const  RenderScript = ({scriptFiles}) => {
   if (!scriptFiles || scriptFiles.length === 0) return;

   const handleLoad  = (file) => {
    //console.log(`Script ${file} cargado correctamente`);
    // Aquí puedes llamar a funciones definidas en tu script si es necesario
  }
  const basePath = '/blocks-js/';

  return (
      <>
        {scriptFiles.map((fileName, index) => (
            <Fragment key={index}>
              <Script
                  key={index}
                  src={`${basePath}${fileName}.js`}
                  //strategy={fileName.includes('.min') ? 'afterInteractive' : 'lazyOnload'}
                  strategy={'afterInteractive'}
                  onLoad={handleLoad(fileName)}
                  onError={(e) => {
                    console.warn(`Error al cargar el script: ${fileName}`);
                  }}
              />
              {fileName === 'form' && <ToastContainer />}
            </Fragment>
        ))}
      </>
  )
}

export default RenderScript;